import { Component } from '@angular/core';

@Component({
    selector: 'home',
    templateUrl: './home.component.html'
})
export class HomeComponent {
}



// WEBPACK FOOTER //
// C:/git/flowdesigner/src/app/home/home.component.ts